export default __webpack_public_path__ + "static/media/ischoolm.b68b9b40.PNG";